import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Cloud Native">
                <h1>Cloud Native App Development Services</h1>
              </div>
              <p className="main_para">
                An approach to building, improving and running apps. Through
                this you will be able to build scalable, flexible, and resilient
                applications that can be updated quickly to meet customer
                demands.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                Creating and delivering an innovative business experience to
                your stakeholders with a secure, robust cloud infrastructure.
              </p>
              <ul>
                <li>Platform Support Services</li>
                <li>Deployment Support</li>
                <li>Virtualization Support</li>
                <li>Network Management</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
